import APPConfig from "../config";

const { INITIAL_GEOLOCATION_LAT, INITIAL_GEOLOCATION_LONG } = APPConfig;

export const contactNumberPattern = /^\(\d{3}\) \d{3}-\d{4}$/;

export const maskUSAPhoneNumber = /^\(\d{3}\) (?!0|1)\d{3}-\d{4}$/;

export const namePattern = /^[A-Za-zÀ-ÖØ-öø-ÿ'-\.\s]+$/;

export const validateContactNumber = (value:string, isProfile?:boolean) =>{
  if (!value) {
    return Promise.reject();
  }

  if(value === "(___) ___-____" && isProfile){
    return Promise.reject("Contact Number is required.");
  }

  if (!contactNumberPattern.test(value)) {
    return Promise.reject("Please enter a valid 10-digit contact number.");
  } else if (!maskUSAPhoneNumber.test(value)) {
    return Promise.reject("Exchange code should not begin with the digits 0 or 1.");
  }

  return Promise.resolve();

}

export const isColorLight = (color:string) => {
  const hexToRgb = (hex:string) => {
    return [parseInt(hex.substr(1, 2), 16), parseInt(hex.substr(3, 2), 16), parseInt(hex.substr(5, 2), 16)];
  };
  
  const rgb = hexToRgb(color);
  const luminance = 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];

  return luminance > 200; 
};

export const initialAddressModalState = () => ({
  address_1: "",
  address_2: "",
  city: "",
  country: "United States",
  zip_code: "",
  state: "",
  geolocation: [Number(INITIAL_GEOLOCATION_LAT), Number(INITIAL_GEOLOCATION_LONG)] as [number, number],
});

export const TransactionFilterOptions = [
  { value: "", label: "All" },
  { value: "delivery", label: "Home Delivery" },
  { value: "pickup", label: "General Market" },
];

export const MedicaidDeliveryFilterOptions = [
  { value: "", label: "All" }
];

export const HomeDevliveryFilterOptions = [
  { value: "", label: "All" },
  { value: "pending", label: "Pending" },
  { value: "delivered", label: "Delivered" },
  { value: "cancelled", label: "Cancelled" },
];


export const FixPaymentOption = [
  { value: "Cash", label: "Cash" },
  { value: "Debit Card", label: "Debit Card" },
  { value: "Credit Card", label: "Credit Card" },
];

export const optionsFilter = [
  {
    value: "month",
    label: "Month",
  },
  {
    value: "quarter",
    label: "Quarter",
  },
  {
    value: "year",
    label: "Year",
  },
];

export const IntervalOptions = [
  { value: "month", label: "Monthly" },
  { value: "quarter", label: "Quarterly" },
  { value: "year", label: "Yearly" },
  { value: "day", label: "Custom Range" },
];